import { MediaPackGuide, MediaPackProgram } from '@calm/evexia-web-sdk';
import { dailyPracticeCardWidth } from '@rhg/components/discover-dailies/daily-packs';
import { PackGuideCard } from '@rhg/components/pack-guide-card';
import { PackProgramCard } from '@rhg/components/pack-program-card';
import {
    PackPageSkeleton,
    PlaceholderWhileOffScreen,
} from '@rhg/components/placeholder-while-offscreen';
import { useActiveCircleId } from '@rhg/hooks/use-active-circle';
import { usePacks } from '@rhg/hooks/use-packs';
import { useEffect } from 'react';
import { MAX_CENTERED_ITEMS, styleCardFooter } from '..';

interface PackGridSectionProps {
    packClass?: string;
    setCenterGridItems: (value: boolean) => void;
}

export const PackGridItems = ({
    packClass,
    setCenterGridItems,
}: PackGridSectionProps) => {
    const { activeCircleId } = useActiveCircleId();
    const { isFetched, packs } = usePacks([packClass ?? ''], activeCircleId);

    useEffect(() => {
        if (
            isFetched &&
            (packs?.[0]?.items?.length ?? Number.POSITIVE_INFINITY) <=
                MAX_CENTERED_ITEMS
        ) {
            setCenterGridItems(true);
        }
    }, [isFetched, packs, setCenterGridItems]);

    if (!isFetched) return null;

    const pack = packs?.[0];

    if (!pack?.items.length) return null;

    return (
        <>
            {pack?.items.map((packItem) => {
                if (packItem.type === 'guide') {
                    return (
                        <PlaceholderWhileOffScreen
                            placeholder={<PackPageSkeleton />}
                            key={packItem?.guideId}
                        >
                            <PackGuideCard
                                willLockIfUnsponsored
                                packClass={pack?.packClass ?? ''}
                                variant="carouselSquare"
                                packGuide={packItem as MediaPackGuide}
                                sx={{ width: dailyPracticeCardWidth }}
                                contentSx={styleCardFooter}
                            />
                        </PlaceholderWhileOffScreen>
                    );
                } else if (packItem.type === 'program') {
                    return (
                        <PlaceholderWhileOffScreen
                            placeholder={<PackPageSkeleton />}
                            key={packItem?.programId}
                        >
                            <PackProgramCard
                                hideImageOverlays
                                packClass={pack?.packClass ?? ''}
                                variant="carouselSquare"
                                packProgram={packItem as MediaPackProgram}
                                sx={{ width: dailyPracticeCardWidth }}
                                contentSx={styleCardFooter}
                            />
                        </PlaceholderWhileOffScreen>
                    );
                }
            })}
        </>
    );
};
